import { render, staticRenderFns } from "./ImageViewModal.vue?vue&type=template&id=1a1f27a6&scoped=true&"
import script from "./ImageViewModal.vue?vue&type=script&lang=ts&"
export * from "./ImageViewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1f27a6",
  null
  
)

export default component.exports